import React, { FC, ReactElement, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './container.module.scss';

import { SizeFormat } from 'types';

interface IContainer {
  children: ReactNode;
  className?: string;
  maxWidth?: SizeFormat;
  padding?: string;
}

const Container: FC<IContainer> = (props): ReactElement => {
  const { maxWidth, children, className, padding } = props;
  const containerStyles = {
    maxWidth: maxWidth || '100%',
    ...(padding !== undefined && { padding }),
  };

  const containerClassNames = classNames(styles.container, className);
  return (
    <div style={containerStyles} className={containerClassNames}>
      {children}
    </div>
  );
};

export { Container };
